import {
  Autocomplete,
  FormControl,
  TextField,
  Chip,
  Checkbox,
  Typography,
  Popper,
  Stack,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { clsx } from 'clsx';

function CustomPopper(props) {
  return (
    <Popper
      {...props}
      placement="bottom-start"
      style={{
        minWidth: 300,
        maxWidth: 500,
        width: 'auto',
      }}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  default: {
    '& .MuiOutlinedInput-root': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  highlightedLabel: {
    '& .MuiInputLabel-root': {
      top: '0 !important',
    },
  },
  highlightedFilter: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
  },
}));

export default function AutoComplete(props) {
  const {
    label,
    value = [],
    options = [],
    onChange,
    multiple = false,
    disabled = false,
    error,
    helperText,
    highlighted = false,
    ...rest
  } = props;

  const renderMultiSelectValue = (selected) => {
    return selected.length > 0 ? <Chip label={`${selected.length} Selected`} /> : null;
  };

  const classes = useStyles();

  return (
    <FormControl
      fullWidth
      disabled={disabled}
      className={clsx(
        classes.default,
        multiple && highlighted && [classes.highlightedLabel, classes.highlightedFilter],
      )}
    >
      <Autocomplete
        autoHighlight
        multiple={multiple}
        PopperComponent={CustomPopper}
        disableCloseOnSelect={multiple}
        options={options}
        value={value}
        getOptionLabel={(option) => option.name ?? option}
        onChange={onChange}
        renderTags={(selected) => renderMultiSelectValue(selected)}
        renderOption={(optionProps, option) => (
          <Stack direction="row" alignItems="center" {...optionProps}>
            {multiple && <Checkbox checked={optionProps['aria-selected']} />}
            <Typography>{option.name}</Typography>
          </Stack>
        )}
        renderInput={(params) => (
          <TextField {...params} label={label} />
        )}
        {...rest}
      />
    </FormControl>
  );
}
